import "./Tokenomics.scss";

import TokenomicsImg from "../../assets/images/tokenomics.png";
import TokenomicsBg from "../../assets/images/tokenomics-bg.png";

export default function Tokenomics() {
	return (
		<div className="tokenomics">
			<img className="decoration tokenomics-bg" src={TokenomicsBg} alt="Tokenomics" />
			<div className="decoration tokenomics-bg-overlay"></div>

			<div className="tokenomics-content-wrapper content-wrapper-lg">
				<div className="decoration light light-1" />
				<div className="decoration light light-2" />
				
				<div className="tokenomics-content">
					<h4 className="tokenomics-small-title" data-aos="zoom-in">Tokenmics</h4>
					<h3 className="tokenomics-title" data-aos="fade-up" data-aos-delay="50">
						Sustainable Ecosystem Growth
					</h3>
					<div className="tokenomics-desc" data-aos="fade-up" data-aos-delay="100">
						The tokenomics of IrisAl focuses on a balanced
						distribution model to ensure sustainable growth,
						efficient utility, and ecosystem integration. It is
						designed to support the platform's long-term vision and
						incentivize key participants within the network.
					</div>
				</div>

				<div className="tokenomics-img">
					<img src={TokenomicsImg} alt="Tokenomics" />
				</div>
			</div>
		</div>
	);
}
